export default "__VITE_ASSET__DXS6JXhf__"